import { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "../../FormControl";
import Select from "@mui/material/Select";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import * as Yup from "yup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Typography, Divider } from "@mui/material";
import { TextField, TextareaAutosize, Checkbox } from "@mui/material";
const toastNotify = (message, isSuccess = true) => {
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

export default function ChecklistSectionDialog({
  editDialogOpen,
  handleDialogClose,
  userId,
  orgId,
  checklistSectionId,
  templateId,
  currentSectionsCount,
  ...props
}) {
  const [details, setDetails] = useState([]);
  const [initialDetails, setInitialDetails] = useState({});
  const [isVisible, setVisible] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const checklistNameRef = useRef(null);

  useEffect(() => {
    setVisible(details.isVisible ?? true);
    setInitialDetails({
      checklistName: details.sectionName,
      // checklistNote: details.checklistNote,
      isVisible: details.isVisible,
    });
  }, [details]);
  const toggleVisibility = (event) => {
    setVisible(event.target.checked);
  };
  useEffect(() => {
    axios
      .get(
        BaseURL.templateTool.GetChecklistSectionDetail +
          "checklistSectionId=" +
          checklistSectionId
      )
      .then((res) => {
        if (res?.data?.status == false) console.error(res?.data);
        if (res.data?.data) {
          setDetails(res.data?.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    if (checklistNameRef.current) {
      checklistNameRef.current.focus();
    }
  }, []);

  const validationSchema = Yup.object().shape({
    checklistName: Yup.string()
      .required("Name is required!")
      .max(200, "Name must be at most 200 characters"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: initialDetails,
  });

  const onSubmit = async (data) => {
    setIsSaving(true);

    let _section = {
      checklistSectionId: checklistSectionId,
      sectionName: data.checklistName,
      IsVisible: isVisible,
      templateId: templateId,
      checklistSubSections: [],
      displayOrder: currentSectionsCount > 0 ? currentSectionsCount + 1 : 0,
    };

    const response = await axios.post(
      BaseURL.templateTool.AddUpdateChecklistSection,
      _section
    );

    if (response.data?.responseCode >= 0) {
      if (response.data?.data) {
        toastNotify("Success", true);
        handleDialogClose(true);
        // checklistSectionId == 0 && setChecklistSectionId(+response.data?.data);
      }
    } else if (response.data?.responseCode == -100) {
      toastNotify(response.data?.responseMessage, false);
    } else if (response.data?.responseCode == -200) {
      const errorMessages = Object.entries(response.data.error).map(
        ([fieldName, messages]) => {
          return `${fieldName}: ${messages.join(", ")}`;
        }
      );

      toastNotify(errorMessages.join(" | "), false);
    } else console.error(response.data);

    setIsSaving(false);
  };
  useEffect(() => {
    reset(initialDetails);
    if (checklistNameRef.current) {
      checklistNameRef.current.focus();
    }
  }, [reset, initialDetails]);

  return (
    <>
      <Dialog open={true} onClose={handleDialogClose} className="w-100 p-2">
        <DialogTitle id="companyAccess-dialog-title">{"Section"}</DialogTitle>
        <DialogContent sx={{ m: 2, width: 450 }}>
          <DialogContentText id="companyAccess-dialog-description">
            <div className="form w-100 mx-0">
              <ToastContainer />
              <div className="row mt-2">
                <div className="col-sm-4 col-md-4 col-xl-4">
                  <span className="input-label-right">
                    Name
                    <small style={{ color: "red" }}> *</small>
                  </span>
                </div>
                <div className="col-sm-8 col-md-8 col-xl-8 mt-1">
                  <TextField
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    inputRef={checklistNameRef}
                    size="small"
                    required
                    id="checklistName"
                    name="checklistName"
                    placeholder="Checklist Section Name"
                    className="form-control text-feild-custom mx-2"
                    {...register("checklistName")}
                  />
                  <Typography className="text-danger mx-2 mt-1">
                    {errors.checklistName?.message}
                  </Typography>
                </div>
              </div>
              <Divider className="mt-3" />

              <div className="row mt-2">
                <div className="col-sm-4 col-md-4 col-xl-4">
                  <span className="input-label-right">Visibility</span>
                </div>
                <div className="col-sm-8 col-md-8 col-xl-8 mt-1">
                  <FormControlLabel
                    className="ms-2"
                    control={
                      <Checkbox
                        name="isVisible"
                        id="isVisible"
                        inputProps={{ "aria-label": "controlled" }}
                        checked={isVisible}
                        onChange={toggleVisibility}
                      />
                    }
                    label={`${isVisible ? "Visible" : "Hidden"}`}
                  />
                </div>

                <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
              </div>

              <Divider className="mt-3" />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}> Cancel</Button>
          {isSaving ? (
            <Box
              style={{
                display: "flex",
                marginLeft: "auto",
                padding: "5px",
              }}
            >
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              style={{ marginLeft: "auto", padding: "12px" }}
            >
              Save
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </>
  );
}
